export const orderGet = "/sys/order";//获取列表
export const orderSeach = (id) => {return "/sys/order/" + id};//查看详情
export const orderAgreements = (orderItemId) => {return "/sys/agreements/" + orderItemId + "/by-orderItem"};//订单协议
export const dealManageExpress = '/mall/express/search'//物流信息